export class QIndexPair {
  constructor() {
    this.fObj = null;
    this.fValue = null;
  }

  InitPair(obj, value) {
    this.fObj = obj;
    this.fValue = value;
  }
}
